import { checkBookingFormFieldsAllowed } from './check-booking-form-fields-allowed';
import type { BulkImportablePass } from './is-bulk-importable-pass.type';

// The bulk text only carries name and email per row. Checks the same fields the single form asks for: the holder's on a
// nominative pass, the booking's otherwise.
export const isBulkImportablePass = ({ bookingFormFields, ticketHolderFormFields, settings }: BulkImportablePass) =>
  checkBookingFormFieldsAllowed(settings.isNominative ? ticketHolderFormFields : bookingFormFields);
